import { delete as unset, get, set } from 'dot-prop'
import cleanSchemaDefinedData from 'fanx-schema/utility/cleanSchemaDefinedData'
import clone from '@fno/lib/clone.js'
import recursiveRemoveEmptyValues from '@fno/lib/recursive-remove-empty-values.js'
import validateProperty from 'fanx-schema/utility/validateProperty'

export default ({ component, page, getKeypath, preChangeMutator }) => ({ detail: { formKey, index, keypath, value, context } }) => {
    const changeTypeIsForArrayItem = page[formKey].type === Array

    const updatedResource = changeTypeIsForArrayItem
        ? clone(context.form[formKey][index])
        : clone(context.form[formKey])

    set(updatedResource, keypath, value)

    const contextFormKeypath = changeTypeIsForArrayItem
        ? `${formKey}.${index}.${keypath}`
        : `${formKey}.${keypath}`

    const actualKeypath = getKeypath ? getKeypath({ formKey, index, keypath, value, context }) : keypath

    // For changes to the schema-defined resources, we can do some data validation
    // and warn if anything is invalid.
    if (formKey !== '$' && !actualKeypath.includes('$')) {

        let cleanableDocument = updatedResource
        if (preChangeMutator) {
            cleanableDocument = clone(updatedResource)
            preChangeMutator({ updatedResource: cleanableDocument, formKey, index, keypath, value, context })
        }
        cleanableDocument = cleanableDocument.attributes

        const errorMessage = validateProperty({
            data: cleanSchemaDefinedData({
                data: cleanableDocument,
                schema: page[formKey].schema
            }),
            key: actualKeypath.replace(/^attributes\./, ''),
            schema: page[formKey].schema
        })

        if (errorMessage && !errorMessage.includes('does not match type of')) {
            set(context, `errors.${contextFormKeypath}`, {
                level: 'warn',
                message: errorMessage
            })
        } else {
            unset(context, `errors.${contextFormKeypath}`)
            // NOTE: in the original `shared/editable/change.js` file, we re-checked
            // and possibly cleared existing errors on each change that is error free.
            // We may need that functionality again?
        }

        context.errors = recursiveRemoveEmptyValues(context.errors)
    }

    const originalResource = changeTypeIsForArrayItem
        ? context.original[formKey][index]
        : context.original[formKey]

    const updated = get(updatedResource, keypath)
    const original = get(originalResource, keypath)
    if (updated !== original) {
        set(context, `changes.${contextFormKeypath}`, updated === undefined || updated === '' ? '' : updated)
    } else {
        unset(context, `changes.${contextFormKeypath}`)
    }

    context.changes = recursiveRemoveEmptyValues(context.changes, { preserveEmptyValues: true })

    component.$set({ context })

}
